import { render, staticRenderFns } from "./StockProductEmbeddable.vue?vue&type=template&id=67236140&"
import script from "./StockProductEmbeddable.vue?vue&type=script&lang=js&"
export * from "./StockProductEmbeddable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports